import React from "react"
import { SelectSeeker } from "@ui-seeker/core"

import { insurance } from "@signals"


export default function InsuranceSelect({ ...props }) {
    return <SelectSeeker
		label="Insurance"
		value={insurance.value}
		isClearable
		onChange={e => insurance.value = e.target.value}
		placeholder="All insurance"
		options={[
			{ label: 'Option 1', value: 'EUR' },
			{ label: 'Option 2', value: 'GBP' }
		]}
		{...props}
	/>
}